

import * as Yup from "yup";

export const currencyValidationSchema = () => Yup.string()
    .required('Source currency is Required')
